import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './Components/login/Login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import {ForgotPasswordComponent} from "./Components/forgot-password/forgot-password.component";
import {ResetPasswordComponent} from "./Components/reset-pwd/reset-password.component";
const routes: Routes = [
  {
    path: '',
    data: {
      title: "Lista utenti",
      urls: [{ title: "Lista utenti", url: "/Login" }, { title: "Lista utenti" }],
    },
    component: LoginComponent,
  },
  {
    path: 'forgot',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset/:token',
    component: ResetPasswordComponent,
  },
];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbModalModule,
    PerfectScrollbarModule,
    // HttpClientModule
  ],
  declarations: [LoginComponent,ForgotPasswordComponent,ResetPasswordComponent],
  // providers: [
  //   { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
  //   { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  //   { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
  // ]
})
export class LoginModule { }
